import { createStore } from "vuex";
import axios from "axios";

export default createStore({
  state: {
    AccessToken:"",
  },
  mutations: {
    getToken(state){
      axios
        .post("https://sckshadmin.laicunwang.com/api/index/camerttoken", {sign:"c4c6cff9b7ec6b87fa953f77ec7e624b"})
        .then((res) => {
          // console.log(res);
          state.AccessToken = res.data.data.data.accessToken
          // console.log(state.AccessToken)
        });
    }
  },
  actions: {},
  modules: {},
});
